import React from 'react';
import './App.css';

import { Nav } from './components/Nav.tsx';

function App() {
  return (

    <div className="App">
      <div id="navbar">
        <Nav />
      </div>
    </div>

  );
}

export default App;
